import { createSlice } from "@reduxjs/toolkit";

import { authApi } from "@/repositories/auth";
import { IUser } from "@/interfaces/user/user";

interface AuthState {
    authenticated: boolean;
    user: IUser|null;
}

const initialState: AuthState = {
    authenticated: false,
    user: null
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state) => {
        state.authenticated = true;
    }).addMatcher(authApi.endpoints.logout.matchFulfilled, (state) => {
        state.user = null;
        state.authenticated = false;
    }).addMatcher(authApi.endpoints.getUser.matchFulfilled, (state, { payload }) => {
        state.user = payload;
        state.authenticated = true;
    }).addMatcher(authApi.endpoints.getUser.matchRejected, (state) => {
        state.user = null;
        state.authenticated = false;
    })
  },
  selectors: {
    selectIsAuthenticated: (state): boolean => state.authenticated,
    selectUser: (state): IUser | null => state.user,
  }
});

export const { 
    selectIsAuthenticated, 
    selectUser,
} = authSlice.selectors;

export default authSlice.reducer;